import { useGetProvincesAndMunicipalities } from "@/api/services/global/constant";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { EMPTY_STR } from "@/constants/string";
import { useChat } from "@/features/chat/providers/ChatProvider";
import { primary } from "@/theme/colors";
import { openInNewTab } from "@/utils/export";
import { findLabelByValue } from "@/utils/object";
import { createUrlWithParams } from "@/utils/url";
import { Stack, styled, Typography } from "@mui/material";

export const RoomHead = () => {
  const { isCompany, currentRoom } = useChat();
  const { provinceOptions, getMunicipalityOptionsByProvince, isLoading } = useGetProvincesAndMunicipalities();
  const province = currentRoom.roomData?.rso?.province || currentRoom.roomData?.company?.province;
  const address = currentRoom.roomData?.rso?.address || currentRoom.roomData?.company?.address;
  const municipality = currentRoom.roomData?.rso?.municipality || currentRoom.roomData?.company?.municipality;
  const provinceLabel = findLabelByValue(provinceOptions, province) || "";
  const municipalityLabel = findLabelByValue(getMunicipalityOptionsByProvince(province ?? ""), municipality) || "";

  const redirectUrl = isCompany
    ? createUrlWithParams(`${process.env.REACT_APP_FRONTEND_MAIN_ROOT_URL}/company/login`, {
        companyCode: currentRoom?.roomData?.company?.companyCode,
      })
    : createUrlWithParams(`${process.env.REACT_APP_FRONTEND_MAIN_ROOT_URL}/login`, {
        rsoRegistrationNumber: currentRoom?.roomData?.rso?.rsoRegistrationNumber,
      });

  if (!currentRoom.roomData || isLoading)
    return (
      <StyledRoomHead height={118}>
        <LoadingArea />
      </StyledRoomHead>
    );
  return (
    <StyledRoomHead>
      <Typography sx={{ marginBottom: "4px" }} variant="sub16Bold">
        {currentRoom.roomData.creator?.fullName || EMPTY_STR.TEXT}
      </Typography>
      <Typography
        variant="body14"
        sx={{
          textDecoration: "underline",
          "&:hover": {
            cursor: "pointer",
            opacity: 0.8,
          },
        }}
        onClick={() => openInNewTab(redirectUrl)}
      >
        {currentRoom.roomData.rso?.rsoName || currentRoom.roomData.company?.companyName || EMPTY_STR.TEXT}・ID:{" "}
        {currentRoom.roomData.rso?.rsoRegistrationNumber || currentRoom.roomData.company?.companyCode}
      </Typography>
      <Typography variant="body14">{`${provinceLabel}${municipalityLabel}${address ?? ""}` || EMPTY_STR.TEXT}</Typography>
    </StyledRoomHead>
  );
};

const StyledRoomHead = styled(Stack)`
  padding: 24px 16px;
  border-radius: 8px;
  background-color: ${primary.main};
  color: white;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
